<template>
  <select-delivery-method-component formAction="authentication/selectphones"/>
</template>

<style>
</style>

<script> 
  import Vue from 'vue';
  import ContextualHelp from 'components/popper-help';
  import SelectDeliveryMethod from './select-delivery-method';

  Vue.component('contextual-help-component', ContextualHelp);
  Vue.component('select-delivery-method-component', SelectDeliveryMethod);
</script>